module.exports = __webpack_public_path__ + "static/media/swipe-right.39d5e7c0.svg";